import { TextAttributeHelper } from './text-attribute-helper';

export class SelectionFromListAttributeHelper extends TextAttributeHelper {}
